<script>
import { validateEmail } from '../helpers';
import { consultingApiUrl, consultingApiKey } from '../variables';
import axios from 'axios';
import OverlayPageLink from '@/components/OverlayPageLink';

export default {
  name: 'ConsultingForm',
  components: {
    OverlayPageLink
  },
  props: {
    data: Object
  },
  data() {
    return {
      errors: [],
      sendError: false,
      formData: {},
      isSaving: false,
      isSuccess: false
    };
  },
  mounted() {
    console.log(this.$el)
  },
  methods: {
    onSubmit(e) {
      e.preventDefault();
      if (this.isSaving) return;

      this.errors = [];

      // validate
      if (!this.formData.consultingType)
        this.errors.push({
          concern: 'consultingType',
          msg: this.$t('consultingForm.filedValidationMsgConsultingType')
        });
      if (this.formData.consultingType === 'tel') {
        if (!this.formData.tel) {
          this.errors.push({
            concern: 'tel',
            msg: this.$t('consultingForm.filedValidationMsgTel')
          });
        }
      }
      if (!validateEmail(this.formData.email))
        this.errors.push({
          concern: 'email',
          msg: this.$t('consultingForm.filedValidationMsgEmail')
        });
      if (!this.formData.message)
        this.errors.push({
          concern: 'message',
          msg: this.$t('consultingForm.filedValidationMsgMessage')
        });
      if (!this.formData.nutzungsbestimmungen)
        this.errors.push({
          concern: 'nutzungsbestimmungen',
          msg: this.$t('consultingForm.filedValidationMsgNutzungsbestimmungen')
        });
      if (!this.formData.datenschutzrichtlinien)
        this.errors.push({
          concern: 'datenschutzrichtlinien',
          msg: this.$t(
            'consultingForm.filedValidationMsgDatenschutzrichtlinien'
          )
        });
      if (this.errors.length > 0) {
        this.scrollTo(this.$refs.form, -180);
        return;
      }

      this.isSaving = true;
      this.sendError = false;
      axios
        .post(
          consultingApiUrl + '/conversations',
          {
            role: this.formData.role,
            age: this.formData.age,
            origin: this.formData.kanton,
            gender: this.formData.gender,
            consulting_type: this.formData.consultingType,
            tel: this.formData.tel,
            reachability: this.formData.reachability,
            email: this.formData.email,
            body: this.formData.message
          },
          {
            headers: {
              Authorization: `Bearer ${consultingApiKey}`
            }
          }
        )
        .then(() => {
          this.isSaving = false;
          this.isSuccess = true;
          this.scrollTo(this.$el, -180);
          this.gtag_report_conversion();
        })
        .catch(() => {
          this.isSaving = false;
          this.sendError = true;
          this.scrollTo(this.$refs.form, -180);
        });
    },
    getValidationMessage(field) {
      const error = this.errors.find(item => item.concern === field);
      return error ? error.msg : null;
    },
    scrollTo(element, offset = 0) {
      if (!element) return;
      setTimeout(() => {
        window.scrollTo(0, element.offsetTop + offset, { behavior: 'smooth' });
      }, 100);
    },
    gtag_report_conversion() {
      gtag('event', 'conversion', {
        'send_to': 'AW-725944146/e5sLCMvDiYsZENKOlNoC',
      });
    }
  }
};
</script>

<template>
  <div>
    <form ref="form" action="" class="consulting-form" v-if="!isSuccess">
      <div class="consulting-form__error">
        <p class="consulting-form__error-title" v-if="errors.length > 0">
          {{ $t('consultingForm.formValidationError') }}
        </p>
        <p class="consulting-form__error-title" v-if="sendError">
          {{ $t('consultingForm.sendError') }}
        </p>
      </div>

      <div class="form-group">
        <label
          class="form-control form-control--email"
          v-bind:class="{
            'form-control--has-error': getValidationMessage('email'),
          }"
        >
          <span class="form-control__label">{{
            $t('consultingForm.inputLabelEmail')
          }}</span>
          <input
            class="form-control__input"
            type="email"
            v-model="formData.email"
            required
          />
          <div class="form-control__messages">
            <span class="form-control__message form-control__message--help"
              >Sie erhalten die Antwort von unserem Beratungsteam an die hier
              angegebene E-Mail-Adresse zugestellt</span
            >
            <span class="form-control__message form-control__message--error">{{
              getValidationMessage('email')
            }}</span>
          </div>
        </label>

        <label
          class="form-control form-control--textarea"
          v-bind:class="{
            'form-control--has-error': getValidationMessage('message'),
          }"
        >
          <span class="consulting-form__span form-control__label">{{
            $t('consultingForm.inputLabelMessage')
          }}</span>
          <textarea
            class="form-control__input"
            rows="12"
            v-model="formData.message"
            required
          ></textarea>
          <div class="form-control__messages">
            <span class="form-control__message form-control__message--error">{{
              getValidationMessage('message')
            }}</span>
          </div>
        </label>
      </div>

      <div class="form-group">
        <label class="form-control form-control--select">
          <span class="form-control__label">{{
            $t('consultingForm.inputLabelRole')
          }}</span>
          <select class="form-control__input" v-model="formData.role">
            <option value="">
              {{ $t('consultingForm.roleOptions.noAnswer') }}
            </option>
            <option value="parents">
              {{ $t('consultingForm.roleOptions.parents') }}
            </option>
            <option value="sibling">
              {{ $t('consultingForm.roleOptions.sibling') }}
            </option>
            <option value="child">
              {{ $t('consultingForm.roleOptions.child') }}
            </option>
            <option value="relative">
              {{ $t('consultingForm.roleOptions.relative') }}
            </option>
            <option value="friend">
              {{ $t('consultingForm.roleOptions.friend') }}
            </option>
            <option value="work">
              {{ $t('consultingForm.roleOptions.work') }}
            </option>
            <option value="school">
              {{ $t('consultingForm.roleOptions.school') }}
            </option>
            <option value="neighbor">
              {{ $t('consultingForm.roleOptions.neighbor') }}
            </option>
            <option value="andere">
              {{ $t('consultingForm.roleOptions.other') }}
            </option>
          </select>
        </label>

        <label class="form-control form-control--number">
          <span class="form-control__label">{{
            $t('consultingForm.inputLabelAge')
          }}</span>
          <input
            class="form-control__input"
            type="number"
            v-model="formData.age"
          />
        </label>

        <label class="form-control form-control--select">
          <span class="form-control__label">{{
            $t('consultingForm.inputLabelKanton')
          }}</span>
          <select class="form-control__input" v-model="formData.kanton">
            <option value="ag">
              {{ $t('consultingForm.kantonOptions.aargau') }}
            </option>
            <option value="ar">
              {{ $t('consultingForm.kantonOptions.appenzellAusserrhoden') }}
            </option>
            <option value="ai">
              {{ $t('consultingForm.kantonOptions.appenzellInnerrhoden') }}
            </option>
            <option value="bl">
              {{ $t('consultingForm.kantonOptions.baselLandschaft') }}
            </option>
            <option value="bs">
              {{ $t('consultingForm.kantonOptions.baselStadt') }}
            </option>
            <option value="be">
              {{ $t('consultingForm.kantonOptions.bern') }}
            </option>
            <option value="fr">
              {{ $t('consultingForm.kantonOptions.freiburg') }}
            </option>
            <option value="ge">
              {{ $t('consultingForm.kantonOptions.genf') }}
            </option>
            <option value="gl">
              {{ $t('consultingForm.kantonOptions.glarus') }}
            </option>
            <option value="gr">
              {{ $t('consultingForm.kantonOptions.graubuenden') }}
            </option>
            <option value="ju">
              {{ $t('consultingForm.kantonOptions.jura') }}
            </option>
            <option value="lu">
              {{ $t('consultingForm.kantonOptions.luzern') }}
            </option>
            <option value="ne">
              {{ $t('consultingForm.kantonOptions.neuenburg') }}
            </option>
            <option value="nw">
              {{ $t('consultingForm.kantonOptions.nidwalden') }}
            </option>
            <option value="ow">
              {{ $t('consultingForm.kantonOptions.obwalden') }}
            </option>
            <option value="sh">
              {{ $t('consultingForm.kantonOptions.schaffhausen') }}
            </option>
            <option value="sz">
              {{ $t('consultingForm.kantonOptions.schwyz') }}
            </option>
            <option value="so">
              {{ $t('consultingForm.kantonOptions.solothurn') }}
            </option>
            <option value="sg">
              {{ $t('consultingForm.kantonOptions.stGallen') }}
            </option>
            <option value="ti">
              {{ $t('consultingForm.kantonOptions.tessin') }}
            </option>
            <option value="th">
              {{ $t('consultingForm.kantonOptions.thurgau') }}
            </option>
            <option value="ur">
              {{ $t('consultingForm.kantonOptions.uri') }}
            </option>
            <option value="wa">
              {{ $t('consultingForm.kantonOptions.waadt') }}
            </option>
            <option value="vs">
              {{ $t('consultingForm.kantonOptions.wallis') }}
            </option>
            <option value="zg">
              {{ $t('consultingForm.kantonOptions.zug') }}
            </option>
            <option value="zh">
              {{ $t('consultingForm.kantonOptions.zuerich') }}
            </option>
          </select>
        </label>

        <label class="form-control form-control--select">
          <span class="form-control__label">{{
            $t('consultingForm.inputLabelGender')
          }}</span>
          <select class="form-control__input" v-model="formData.gender">
            <option value="">
              {{ $t('consultingForm.genderOptions.none') }}
            </option>
            <option value="male">
              {{ $t('consultingForm.genderOptions.male') }}
            </option>
            <option value="female">
              {{ $t('consultingForm.genderOptions.female') }}
            </option>
            <option value="divers">
              {{ $t('consultingForm.genderOptions.other') }}
            </option>
          </select>
        </label>
      </div>

      <div class="form-group">
        <h3 class="form-group__title">{{ $t('consultingForm.inputLabelConsultingType') }}</h3>
        <label class="form-control form-control--checkbox">
          <input
            type="radio"
            class="form-control__input"
            value="email"
            v-model="formData.consultingType"
          />
          <span class="form-control__label">
            {{ $t('consultingForm.emailConsulting') }}
          </span>
        </label>

        <label class="form-control form-control--checkbox">
          <input
            type="radio"
            class="form-control__input"
            value="tel"
            v-model="formData.consultingType"
          />
          <span class="form-control__label">
            {{ $t('consultingForm.telConsulting') }}
          </span>
        </label>

        <label class="form-control form-control--checkbox">
          <input
            type="radio"
            class="form-control__input"
            value="video"
            v-model="formData.consultingType"
          />
          <span class="form-control__label">
            {{ $t('consultingForm.videoCallConsulting') }}
          </span>

          <div class="form-control__messages">
            <span class="form-control__message form-control__message--error">
              {{ getValidationMessage('consultingType') }}
            </span>
          </div>
        </label>

        <template v-if="formData.consultingType === 'tel'">
          <label
            class="form-control form-control--tel"
            v-bind:class="{
              'form-control--has-error': getValidationMessage('tel'),
            }">
            <span class="form-control__label">
              {{ $t('consultingForm.inputLabelTel') }}
            </span>
            <input
              class="form-control__input"
              type="tel"
              v-model="formData.tel"
              required
            />
            <div class="form-control__messages">
              <span class="form-control__message form-control__message--error">
                {{ getValidationMessage('tel') }}
              </span>
            </div>
          </label>

          <label
            class="form-control"
            v-bind:class="{
              'form-control--has-error': getValidationMessage('reachability'),
            }">
            <span class="form-control__label">
              {{ $t('consultingForm.inputLabelReachability') }}
            </span>
            <input
              class="form-control__input"
              type="text"
              v-model="formData.reachability"
            />
            <div class="form-control__messages">
              <span class="form-control__message form-control__message--help">
                {{ $t('consultingForm.inputHelpReachability') }}
              </span>
            </div>
          </label>
        </template>
      </div>

      <div class="form-group">
        <label
          class="form-control form-control--checkbox"
          v-bind:class="{
            'form-control--has-error': getValidationMessage(
              'nutzungsbestimmungen'
            ),
          }"
        >
          <input
            type="checkbox"
            class="form-control__input"
            value="true"
            v-model="formData.nutzungsbestimmungen"
          />
          <span class="form-control__label"
            >Ich stimme den
            <overlay-page-link
              v-bind:type="'default'"
              v-bind:label="'Nutzungsbedingungen'"
              v-bind:page="data.nutzungsbestimmungen"
            ></overlay-page-link> zu.</span
          >
          <div class="form-control__messages">
            <span class="form-control__message form-control__message--error">{{
              getValidationMessage('nutzungsbestimmungen')
            }}</span>
          </div>
        </label>

        <label
          class="form-control form-control--checkbox"
          v-bind:class="{
            'form-control--has-error': getValidationMessage(
              'datenschutzrichtlinien'
            ),
          }"
        >
          <input
            type="checkbox"
            class="form-control__input"
            value="true"
            v-model="formData.datenschutzrichtlinien"
          />
          <span class="form-control__label"
            >Ich habe die
            <overlay-page-link
              v-bind:type="'default'"
              v-bind:label="'Datenschutzerklärung'"
              v-bind:page="data.datenschutzrichtlinien"
            ></overlay-page-link> zur Kenntnis genommen.</span
          >
          <div class="form-control__messages">
            <span class="form-control__message form-control__message--error">{{
              getValidationMessage('datenschutzrichtlinien')
            }}</span>
          </div>
        </label>
      </div>

      <div class="consulting-form__actions">
        <button
          class="consulting-form__button button button--primary"
          v-on:click="onSubmit($event)"
        >
          <span v-if="!isSaving">{{ $t('consultingForm.buttonSave') }}</span
          ><span v-if="isSaving">{{ $t('consultingForm.loading') }}</span>
        </button>
      </div>
    </form>

    <!-- Success -->
    <div ref="success" class="consulting-form__success" v-else>
      <h3 class="consulting-form__success-title">Bestätigung Ihrer E-Mail-Adresse</h3>
      <p>Vielen Dank für Ihre Anfrage an die Angehörigenbegleitung von «Leben mit Schizophrenie».</p>
      <p>Damit unser Beratungsteam Ihre Anfrage bearbeiten kann, müssen wir aus Vertraulichkeitsgründen Ihre Identität überprüfen. Sie erhalten an die von Ihnen angegebene Adresse eine E-Mail mit einem Link zur Bestätigung Ihrer E-Mail-Adresse. Bitte überprüfen Sie Ihren Posteingang.</p>
      <p>Bei Fragen stehen wir Ihnen gerne unter <a href="mailto:beratung@lebenmitschizophrenie.ch">beratung@lebenmitschizophrenie.ch</a> zur Verfügung. </p>
      <p>Hinweis: Bei akuten Notsituationen wenden Sie sich bitte an die Notfallnummern 144 (Notruf), 117 (Polizei) oder 147 (Telefonhilfe für Kinder und Jugendliche).</p>
    </div>
        
  </div>
</template>

<style lang="scss" scoped>
.consulting-form__actions {
  margin-top: 6rem;
}

.consulting-form__error-title {
  margin-bottom: 4rem;
  font-weight: 300;
  color: $color-danger;
}

.consulting-form__success {
  margin-top: 7.2rem;
  padding: 2rem 2.8rem;
  background-color: $color-card-background;
  font-size: 1.8rem;
  letter-spacing: 0.032rem;
  line-height: 1.67;
}

.consulting-form__success-title {
  margin-top: 0;
}
</style>
